import React from 'react';
import { element, number, shape, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { TodaysRecommendations } from '@thd-olt-component-react/thd-recs-containers';
import { LayoutManager } from '@thd-olt-component-react/layout-manager';
import { Card, CardTitle } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from '../components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedTodaysRecommendationsForYou({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,

  id,
  mcvisID,
  store,
  brandTitleMaxLine,
  slidesPer,
}) {
  const { storeId, storeZip: zipCode } = store;
  return (
    <LayoutManager name="todays_recs">
      <QueryProvider cacheKey="todays_recs">
        <Hydrator
          id="todaysRecommendationsForYou-php-hydrator"
          className={styles('u-height-100')}
          scrollBuffer={SCROLL_BUFFER}
          delay={HOMEPAGE_DELAY_STANDARD}
          placeholder={PLACEHOLDER}
        >
          <Card>
            {/**
             * @TODO
             * Refactor `app.scss` to use CSS modules.
             */}
            <CardTitle
              className="card__title u-width-100"
              title="Today's Recommendations for You"
            />
            <TodaysRecommendations
              brandTitleMaxLine={brandTitleMaxLine}
              customerID={mcvisID}
              hideTitle
              requestKey="2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg"
              showFallback
              showLoading
              storeId={storeId}
              zipCode={+zipCode}
              noATCFulfillment
              slidesPer={slidesPer}
              entryId={id}
            />
          </Card>
        </Hydrator>
      </QueryProvider>
    </LayoutManager>
  );
}

CustomRenderedTodaysRecommendationsForYou.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,

  mcvisID: string,
  brandTitleMaxLine: number,
  slidesPer: number,
  store: shape({
    storeId: string,
    storeZip: string,
  }),
  id: string,
};

CustomRenderedTodaysRecommendationsForYou.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,

  mcvisID: undefined,
  brandTitleMaxLine: undefined,
  store: {
    storeId: '121',
    storeZip: '30339',
  },
  slidesPer: undefined,
  id: undefined,
};
